import { Section } from './section';

export const SECTIONS_WITHOUT_NOTIFICATIONS_BAR = [Section.InstallCode, Section.Onboarding, Section.Subscription];
